import { cdnOrigin } from './environments';
import { hash } from './hash';
import { keys as headerKeys } from './headers';
import { lang } from './page';

const requests = new Map();

export async function request(uri, options = { method: 'GET', headers: {}, body: '', params: {} }) {
  const url = new URL(uri, cdnOrigin);
  console.log('[REQUEST] ', url.toString(), options);
  if (url.href.startsWith(window.location.origin)) {
    let llang = lang;

    if (llang.length > 0) {
      if (url.searchParams.has('lang') === false) {
        url.searchParams.set('lang', llang);
      } else {
        llang = url.searchParams.get('lang');
      }

      if ('accept-language' in options.headers === false) {
        options.headers[headerKeys.accept] = `${llang};q=0.9`;
      }
    }
  }

  if (options.params && Reflect.ownKeys(options.params).length) {
    url.search = new URLSearchParams(options.params).toString();
  }

  const key = `${options.method || 'GET'}_${hash(url.href)}_${hash(
    options.headers[headerKeys.auth] || 'anon',
  )}_${hash(JSON.stringify(options.body || ''))}`;

  if (requests.has(key) === false) {
    if (options.method === 'GET' || options.method === 'HEAD') {
      delete options.body;
    }

    const promise = fetch(url.href, options)
      .then((arg) => {
        requests.delete(key);

        return arg;
      })
      .catch((err) => {
        requests.delete(key);

        throw err;
      });

    requests.set(key, promise);
  }

  // Returns cloned response to handle potential 1-n relationship
  return requests.get(key).then((arg) => arg.clone());
}
